import React from "react";
import DetailBuildingDamage from "./DetailBuildingDamage";
import { formatNumber } from "../../../../lib/commonFunctions";

interface IProps {
  // banner: NewsData;
  damagedBuildings: string;
  ally: boolean;
  mageXp?: number;
  thiefXp?: number;
}

const NewsPersonSummary = ({
  // banner,
  damagedBuildings,
  ally,
  mageXp,
  thiefXp
}: IProps) => {
  const siegeBuildings = false; // banner && banner.details[NEWS_DETAIL.SiegeDamagedBuildings]
  // && (ally !== banner.success);
  // const destroyerBuildings = !ally && banner && banner.success
  //   && banner.details[NEWS_DETAIL.DestroyerBuildingDamage];
  const showDamagedBuildings = siegeBuildings || damagedBuildings;
  // || (ally && !banner.success && banner.details[NEWS_DETAIL.DestroyerBuildingDamage]);
  return (
    <div className="text-item" style={{ fontWeight: "normal", borderBottom: "1px solid #242424", borderTop: "none" }}>
      <div id="news-detail-{{ banner.id }}" style={{ paddingTop: "7px", paddingBottom: "7px" }}>
        {showDamagedBuildings && <div>
          Building damage:<DetailBuildingDamage
          // buildingDamage={
          //   `${siegeBuildings
          //   ? `${banner.details[NEWS_DETAIL.SiegeDamagedBuildings].value};` : ""}${(ally
          //     && !banner.success
          //     && `${banner.details[NEWS_DETAIL.DestroyerBuildingDamage]?.value};`)
          //     || ""}${damagedBuildings}`
          // }
          buildingDamage={damagedBuildings}
        />
        </div>}
        {/* {destroyerBuildings && <div> */}
        {/*  Destroyer effect: <DetailBuildingDamage */}
        {/*  buildingDamage={`${destroyerBuildings
        ? banner.details[NEWS_DETAIL.DestroyerBuildingDamage].value : ""}`} */}
        {/* /> */}
        {/* </div>} */}
        {/* {ally && banner.details[NEWS_DETAIL.ScorchedEarthDamage] */}
        {/* && banner.details[NEWS_DETAIL.ScorchedEarthDamage].value */}
        {/* && <div> */}
        {/*  Scorched earth damage: */}
        {/*  <DetailBuildingDamage */}
        {/*    buildingDamage={banner.details[NEWS_DETAIL.ScorchedEarthDamage].value} */}
        {/*  /> */}
        {/* </div>} */}
        {ally && <>
          <br/>
          <div>
            Generals experience gain:
            {/* <div>Soldier: <em>{banner.details[NEWS_DETAIL.GeneralExpGain] */}
            {/*  ? formatNumber(Number
            .parseInt(banner.details[NEWS_DETAIL.GeneralExpGain].value, */}
            {/*    10)) */}
            {/*  : 0}</em> XP</div> */}
            <div>Mage: <em>{formatNumber(mageXp || 0)}</em> XP</div>
            <div>Thief: <em>{formatNumber(thiefXp || 0)}</em> XP</div>
          </div>
        </>
        }
      </div>
    </div>
  )
}

export default NewsPersonSummary
